var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrendFlat = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 8C1 6.61929 2.11929 5.5 3.5 5.5H12.5C13.8807 5.5 15 6.61929 15 8C15 9.38071 13.8807 10.5 12.5 10.5H3.5C2.11929 10.5 1 9.38071 1 8Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrendFlat);
export default ForwardRef;